import type { IApplicationState } from 'shared/types/redux';

export const selectCPDDealType = (state: IApplicationState) => state.cpd.cpdDealType;
